import { render } from "./CrmZaloMultiModuleHub.vue?vue&type=template&id=558bd2eb"
import script from "./CrmZaloMultiModuleHub.vue?vue&type=script&lang=js"
export * from "./CrmZaloMultiModuleHub.vue?vue&type=script&lang=js"

import "./CrmZaloMultiModuleHub.vue?vue&type=style&index=0&id=558bd2eb&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__